/* tslint:disable */
/* eslint-disable */
/* @relayHash cfc0bbfb3bc727633d3bcfe7ce2cd7e3 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CartNavRefetchQueryVariables = {
    fetchLocalItems: boolean;
    fetchPortfolioItems: boolean;
    hasUserId: boolean;
    localItemIds?: Array<string | null> | null;
    userIds?: Array<string> | null;
};
export type CartNavRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"CartNav_viewer">;
    };
};
export type CartNavRefetchQuery = {
    readonly response: CartNavRefetchQueryResponse;
    readonly variables: CartNavRefetchQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "fetchLocalItems",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchPortfolioItems",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "localItemIds",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String!]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "convertedAmountList",
    "storageKey": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v3/*: any*/)
    ]
  }
],
v6 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "pdpURL",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "serviceId",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isSold",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "photos",
    "storageKey": null,
    "args": null,
    "concreteType": "ItemPhoto",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "versions",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemPhotoVersion",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "webPath",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "type",
            "storageKey": null,
            "args": null,
            "concreteType": "ImageVersionType",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      (v1/*: any*/)
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "pricing",
    "storageKey": null,
    "args": null,
    "concreteType": "ItemPricing",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "netPrice",
        "storageKey": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "plural": false,
        "selections": (v5/*: any*/)
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "salePrice",
        "storageKey": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "plural": false,
        "selections": (v5/*: any*/)
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "retailPrice",
        "storageKey": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "plural": false,
        "selections": (v5/*: any*/)
      }
    ]
  },
  (v1/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CartNavRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CartNav_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "fetchLocalItems",
                "variableName": "fetchLocalItems"
              },
              {
                "kind": "Variable",
                "name": "fetchPortfolioItems",
                "variableName": "fetchPortfolioItems"
              },
              {
                "kind": "Variable",
                "name": "localItemIds",
                "variableName": "localItemIds"
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CartNavRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchLocalItems",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "items",
                "storageKey": null,
                "args": [
                  (v2/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "itemIds",
                    "variableName": "localItemIds"
                  }
                ],
                "concreteType": "ItemsConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemsEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": (v6/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "portfolios",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "portfolioTypes",
                    "value": [
                      "CART"
                    ]
                  },
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds"
                  }
                ],
                "concreteType": "PortfoliosConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": "items(first:3)",
                            "args": [
                              (v2/*: any*/)
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "totalResults",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "Condition",
                                "passingValue": true,
                                "condition": "fetchPortfolioItems",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioItemsEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "PortfolioItemV2",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "item",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": (v6/*: any*/)
                                          },
                                          (v1/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CartNavRefetchQuery",
    "id": "ferrum/289.0.0-2020-11-03T20:56:25.991Z/CartNavRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '66f9037c9d01b7778038030182b7bb5f';
export default node;
